import styled, { css } from "styled-components";
import { Portal } from "@diana-ui/portal";
export var StyledPortal = /*#__PURE__*/ styled(Portal).withConfig({
  displayName: "Popoverstyle__StyledPortal"
})([""]);
/**
 * Component container
 */

export var Container = /*#__PURE__*/ styled.div.withConfig({
  displayName: "Popoverstyle__Container"
})(() => css(["position:relative;&.disabled{pointer-events:none;}"]));
export var StyledPopover = /*#__PURE__*/ styled.div.withConfig({
  displayName: "Popoverstyle__StyledPopover"
})(() => css(["display:flex;z-index:10;"]));
export var Overlay = /*#__PURE__*/ styled.div.withConfig({
  displayName: "Popoverstyle__Overlay"
})(_ref => {
  var { theme } = _ref;
  return css(
    ["position:fixed;top:0;left:0;width:100%;height:100%;background-color:", ";z-index:10;"],
    theme.colors.background.overlay
  );
});
export var HeaderWrapper = /*#__PURE__*/ styled.div.withConfig({
  displayName: "Popoverstyle__HeaderWrapper"
})(() => css(["", ".show-on-hover &{cursor:pointer;}"], Container));
export var Content = /*#__PURE__*/ styled.div.withConfig({
  displayName: "Popoverstyle__Content"
})(() => css(["width:100%;"]));
